import {
    CLEAR_ALL,
    CLEAR_CRUD_CODE,
    DELETE_CODE_SUCCESS,
    GET_CRUD_CODE_REQUEST,
    GET_CRUD_CODE_SUCCESS,
    GET_CRUD_CODE_ERROR,
    GET_CUSTOM_CODE_REQUEST,
    GET_CUSTOM_CODE_SUCCESS,
    GET_CUSTOM_CODE_ERROR,
    GET_CUSTOM_CODES_REQUEST,
    GET_CUSTOM_CODES_SUCCESS,
    GET_CUSTOM_CODES_ERROR,
} from 'constants/ActionTypes';

const initialState = {
    list: [],
    listLoading: false,
    listError: false,
    crudCode: null,
    crudCodeLoading: false,
    crudCodeError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CUSTOM_CODES_REQUEST:
            return {
                ...state,
                listLoading: true,
            };

        case GET_CUSTOM_CODES_SUCCESS:
            return {
                ...state,
                list: action.payload,
                listLoading: false,
            };

        case GET_CUSTOM_CODES_ERROR:
            return {
                ...state,
                list: null,
                listLoading: false,
            };

        case GET_CUSTOM_CODE_REQUEST:
        case GET_CRUD_CODE_REQUEST:
            return {
                ...state,
                crudCode: null,
                crudCodeLoading: true,
                crudCodeError: false,
            };

        case GET_CUSTOM_CODE_SUCCESS:
        case GET_CRUD_CODE_SUCCESS:
            return {
                ...state,
                crudCode: action.payload,
                crudCodeLoading: false,
                crudCodeError: false,
            };

        case GET_CUSTOM_CODE_ERROR:
        case GET_CRUD_CODE_ERROR:
            return {
                ...state,
                crudCode: null,
                crudCodeLoading: true,
                crudCodeError: true,
            };

        case DELETE_CODE_SUCCESS: {
            const name = action.payload;
            const index = state.list.findIndex((event) => event.name === name);
            if (index > -1) {
                state.list.splice(index, 1);
            }
            return {
                ...state,
            };
        }

        case CLEAR_CRUD_CODE:
            return {
                ...state,
                crudCode: null,
            };

        case CLEAR_ALL:
            return initialState;

        default:
            return {
                ...state,
            };
    }
}
